"use-strict";

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");
    const footer = document.querySelector(".product-sticky-hide");

    if (!primaryBtn) return;

    var isVisible = true;
    window.addEventListener("scroll", function () {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
        }
      }
    });
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);

class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    this.handleWhenSwatchUpdate();
  }

  handleWhenSwatchUpdate() {
    this.updateOptions();
    const arrayItem = this.updateMasterId(this.variantData);
    this.handleMediaCompare(arrayItem);
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem) return;
    const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            this.remove();
            if (document.querySelector(".product-recommendations-heading")) {
              document
                .querySelector(".product-recommendations-heading")
                .remove();
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.innit();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 0);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#minicart-form").innerHTML;
            const countdown = cart.querySelector(".cart-countdown-time");
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (countdown && html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          });
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

// js for product addons
class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    html.classList.remove("hidden");
    this.initPopup(
      html,
      `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
    );
  }
}
customElements.define("product-addons", ProductAddons);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
            save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            "text/html"
          );
          elementToReplace.innerHTML =
            html.querySelector("#minicart-form").innerHTML;
          const countdown = cart.querySelector(".cart-countdown-time");
          const html_countdown = html.querySelector(".cart-countdown-time");
          if (countdown && html_countdown) {
            countdown.innerHTML = html_countdown.innerHTML;
          }
        });
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      total.querySelector(".total-price .price__sale .price-item").innerHTML =
        Shopify.formatMoney(total_compare_price, cartStrings.money_format);
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      if (total_compare_price > total_price) {
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

// BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();
/* ---------------------------------------------------------------------------
   Poster + Rahmen in einem Rutsch in den Warenkorb (AJAX) – finale Version
   --------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', async () => {
  // Nur Poster: alte 2-Optionen-Produkte ODER neue markierte Größen-only-Poster.
  // Reine Bilderrahmen und sonstige Produkte bekommen KEINEN Rahmen-Konfigurator.
  const isSizeOnlyPoster = Boolean(document.querySelector('[data-deinspar-poster-mode="size-only"]'));
  const hasLegacyPosterFrame = Boolean(document.querySelector(
    '[data-custom-frame-value][data-deinspar-frame-key="none"]:not([data-deinspar-virtual-frame])'
  ));
  if (!isSizeOnlyPoster && !hasLegacyPosterFrame) return;

  /* ▼ Basis-Elemente ----------------------------------------------------- */
  const dropdowns  = document.querySelectorAll('.option_drop_value .option_value');
  const mainButton = document.querySelector('[name="add"]');
  const loaderIcon = document.querySelector('.icon-load');

  /* ▼ Custom UI – moderne Größe + Rahmen -------------------------------- */
  const customSizePicker = document.querySelector('[data-custom-size-picker]');
  const customSizeTrigger = document.querySelector('[data-custom-size-trigger]');
  const customSizeTriggerText = document.querySelector('[data-custom-size-trigger-text]');
  const customSizeTriggerPrice = document.querySelector('[data-custom-size-trigger-price]');
  const customSizeDropdown = document.querySelector('[data-custom-size-dropdown]');
  const customSizeSheet = document.querySelector('[data-custom-size-sheet]');
  const customSizeCloseButtons = document.querySelectorAll('[data-custom-size-close]');
  const customSizeOptions = document.querySelectorAll('[data-custom-size-value]');
  // A frame may later become an actual option2 variant: prefer that native card.
  document.querySelectorAll('[data-deinspar-virtual-frame="true"]').forEach(card => {
    const key = card.dataset.deinsparFrameKey;
    const nativeExists = [...document.querySelectorAll('[data-custom-frame-value]')].some(other =>
      other !== card && !other.hasAttribute('data-deinspar-virtual-frame') && other.dataset.deinsparFrameKey === key
    );
    if (nativeExists) card.remove();
  });
  const customFrameCards = document.querySelectorAll('[data-custom-frame-value]');
  const customFrameCardPrices = document.querySelectorAll('[data-frame-card-price]');
  const customFramePicker = document.querySelector('[data-custom-frame-picker]');
  const customFrameTrigger = document.querySelector('[data-custom-frame-trigger]');
  const customFrameDropdown = document.querySelector('[data-custom-frame-dropdown]');
  const customFrameTriggerText = document.querySelector('[data-custom-frame-trigger-text]');
  const customFrameTriggerPrice = document.querySelector('[data-custom-frame-trigger-price]');
  const customFrameTriggerDot = document.querySelector('[data-custom-frame-trigger-dot]');
  const customFrameSheet = document.querySelector('[data-custom-frame-sheet]');
  const customFrameSheetOptions = document.querySelector('[data-custom-frame-sheet-options]');
  const customFrameCloseButtons = document.querySelectorAll('[data-custom-frame-close]');
  // Preserve original position so the same buttons work on desktop AND mobile.
  const frameDropdownParent = customFrameDropdown?.parentElement;
  const frameDropdownNextSibling = customFrameDropdown?.nextSibling;
  const nativeVariantRoot = document.querySelector('.custom-variant-picker__native');
  // Für neue Poster gibt es kein natives option2. "Ohne Rahmen" ist Standard.
  let virtualFrameKey = isSizeOnlyPoster ? 'none' : '';
  let virtualFrameLabel = isSizeOnlyPoster
    ? (document.querySelector('[data-deinspar-frame-key="none"] .custom-frame-card__title')?.textContent?.trim() || 'No Frame')
    : '';

  function restoreFrameDropdown() {
    if (!customFrameDropdown || !frameDropdownParent ||
        customFrameDropdown.parentElement === frameDropdownParent) return;
    if (frameDropdownNextSibling?.parentNode === frameDropdownParent) {
      frameDropdownParent.insertBefore(customFrameDropdown, frameDropdownNextSibling);
    } else {
      frameDropdownParent.appendChild(customFrameDropdown);
    }
  }

  function openCustomFramePicker() {
    if (!customFramePicker || !customFrameDropdown) return;
    closeCustomSizePicker();
    customFramePicker.classList.add('is-open');
    if (isMobileCustomSizeView() && customFrameSheet && customFrameSheetOptions) {
      // Reuse, rather than duplicate, the buttons and their selection handlers.
      customFrameSheetOptions.appendChild(customFrameDropdown);
      customFrameSheet.hidden = false;
      document.body.classList.add('custom-size-sheet-open');
    } else {
      restoreFrameDropdown();
      if (customFrameSheet) customFrameSheet.hidden = true;
    }
    customFrameDropdown.hidden = false;
    customFrameTrigger?.setAttribute('aria-expanded', 'true');
  }

  function closeCustomFramePicker() {
    if (!customFramePicker || !customFrameDropdown) return;
    customFramePicker.classList.remove('is-open');
    customFrameDropdown.hidden = true;
    if (customFrameSheet) customFrameSheet.hidden = true;
    restoreFrameDropdown();
    document.body.classList.remove('custom-size-sheet-open');
    customFrameTrigger?.setAttribute('aria-expanded', 'false');
  }

  // Preisfarben der Rahmendropdowns wie beim Groessendropdown:
  // Normalpreis schwarz, reduzierter Preis rot, Vergleichspreis grau/durchgestrichen.
  function setFramePriceSaleState(priceEl, price, compareAtPrice) {
    if (!priceEl || !priceEl.parentElement) return;
    let priceGroup = priceEl.parentElement.classList.contains('deinspar-frame-price-group')
      ? priceEl.parentElement : null;
    if (!priceGroup) {
      priceGroup = document.createElement('span');
      priceGroup.className = 'deinspar-frame-price-group';
      priceEl.parentElement.insertBefore(priceGroup, priceEl);
      priceGroup.appendChild(priceEl);
    }

    const isSale = Number(compareAtPrice) > Number(price);
    priceEl.classList.toggle('is-sale', isSale);
    let compareEl = priceGroup.querySelector('.deinspar-frame-price-compare');
    if (isSale) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'deinspar-frame-price-compare';
        priceGroup.appendChild(compareEl);
      }
      compareEl.textContent = '+' + formatFrameMoney(compareAtPrice);
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function updateCustomFrameTrigger() {
    const selected = [...customFrameCards].find(card => card.classList.contains('is-active') && !card.hidden);
    if (!selected) return;
    const key = selected.dataset.deinsparFrameKey || '';
    const label = selected.querySelector('.custom-frame-card__title')?.textContent?.trim() || '';
    const price = selected.querySelector('[data-frame-card-price]')?.textContent?.trim() || '';
    if (customFrameTriggerText) customFrameTriggerText.textContent = label;
    if (customFrameTriggerPrice) {
      customFrameTriggerPrice.textContent = price;
      const choice = lookupFrameVariant(key, getCurrentSizeLabel());
      const setPrices = choice.status === 'found'
        ? getFrameSetPrices(choice.variant)
        : { price: 0, compareAtPrice: 0 };
      setFramePriceSaleState(
        customFrameTriggerPrice,
        setPrices.price,
        setPrices.compareAtPrice
      );
    }
    if (customFrameTriggerDot) {
      customFrameTriggerDot.className = 'custom-frame-picker__selection-dot';
      customFrameTriggerDot.dataset.frameColor = key;
      customFrameTriggerDot.textContent = '';
      customFrameTriggerDot.replaceChildren();
      const selectedImage = selected.querySelector('.custom-frame-card__image-wrap img');
      if (selectedImage) {
        const thumb = selectedImage.cloneNode(true);
        thumb.removeAttribute('loading');
        customFrameTriggerDot.appendChild(thumb);
      }
    }
  }

  function isMobileCustomSizeView() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function openCustomSizePicker() {
    if (!customSizePicker) return;
    closeCustomFramePicker();

    customSizePicker.classList.add('is-open');

    if (customSizeTrigger) {
      customSizeTrigger.setAttribute('aria-expanded', 'true');
    }

    if (isMobileCustomSizeView()) {
      if (customSizeDropdown) customSizeDropdown.hidden = true;
      if (customSizeSheet) customSizeSheet.hidden = false;
      document.body.classList.add('custom-size-sheet-open');
    } else {
      if (customSizeDropdown) customSizeDropdown.hidden = false;
      if (customSizeSheet) customSizeSheet.hidden = true;
    }
  }

  function closeCustomSizePicker() {
    if (!customSizePicker) return;

    customSizePicker.classList.remove('is-open');

    if (customSizeTrigger) {
      customSizeTrigger.setAttribute('aria-expanded', 'false');
    }

    if (customSizeDropdown) customSizeDropdown.hidden = true;
    if (customSizeSheet) customSizeSheet.hidden = true;

    document.body.classList.remove('custom-size-sheet-open');
  }

  function getCurrentSizeLabel() {
    return (dropdowns[0]?.textContent || '').trim();
  }

  function getCurrentFrameLabel() {
    return virtualFrameKey ? virtualFrameLabel : (dropdowns[1]?.textContent || '').trim();
  }

  // Overlays are taken from the actual product gallery, not from translated names.
  function refreshFrameOverlay() {
    const frameKey = virtualFrameKey || getFrameKey((dropdowns[1]?.textContent || '').trim());
    const overlayNames = {
      eiche: 'oak', weiss: 'white', schwarz: 'black', dunkelbraun: 'dark',
      greige: 'greige', grau: 'slate-grey', rot: 'red', mintgrun: 'mint-green',
      dunkelgrun: 'dark-green', blau: 'blue', orange: 'orange',
      hellrosa: 'pale-pink', gelb: 'yellow'
    };
    const images = [...document.querySelectorAll('.overlay_images img')];
    images.forEach(img => { img.style.display = 'none'; });
    const matchPrefix = 'frame-' + (overlayNames[frameKey] || '__none__') + '-';
    const selected = images.find(img => img.id.startsWith(matchPrefix));
    if (selected) selected.style.display = 'block';
  }

  function getNativeFieldsets() {
    if (!nativeVariantRoot) return [];
    return Array.from(nativeVariantRoot.querySelectorAll('.product-form__input--dropdown'));
  }

  function findNativeLabelByOptionValue(optionIndex, optionValue) {
    const safeValue = String(optionValue || '').trim();
    if (!safeValue) return null;

    const fieldsets = getNativeFieldsets();
    const fieldset = fieldsets[optionIndex];
    if (!fieldset) return null;

    const labels = fieldset.querySelectorAll('.product__color-swatches--js[data-option-swatch-value]');

    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      const value = String(label.getAttribute('data-option-swatch-value') || '').trim();

      if (value === safeValue) {
        return label;
      }
    }

    return null;
  }

  function clickNativeOption(optionIndex, optionValue) {
    const safeValue = String(optionValue || '').trim();
    if (!safeValue) return false;

    const fieldsets = getNativeFieldsets();
    const fieldset = fieldsets[optionIndex];
    if (!fieldset) return false;

    const inputs = Array.from(
      fieldset.querySelectorAll('input[type="radio"][form]')
    );

    const targetInput = inputs.find(function(input) {
      return String(input.value || '').trim() === safeValue;
    });

    if (!targetInput || targetInput.disabled) return false;

    targetInput.checked = true;
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    targetInput.dispatchEvent(new Event('input', { bubbles: true }));

    const relatedLabel = targetInput.id
      ? fieldset.querySelector('label[for="' + targetInput.id + '"]')
      : null;

    if (relatedLabel) {
      relatedLabel.click();
    }

    return true;
  }

  // Poster-Größe: Sale-Preis + Vergleichspreis wie beim Rahmen auch im
  // geschlossenen Dropdown darstellen. Die Werte kommen aus Shopify-Liquid.
  function setSizeTriggerPriceSaleState(priceEl, priceCents, compareCents) {
    if (!priceEl || !priceEl.parentElement) return;

    let priceGroup = priceEl.parentElement.classList.contains('deinspar-size-price-group')
      ? priceEl.parentElement : null;
    if (!priceGroup) {
      priceGroup = document.createElement('span');
      priceGroup.className = 'deinspar-size-price-group';
      priceEl.parentElement.insertBefore(priceGroup, priceEl);
      priceGroup.appendChild(priceEl);
    }

    const onSale = Number.isFinite(Number(priceCents)) &&
      Number.isFinite(Number(compareCents)) &&
      Number(compareCents) > Number(priceCents);
    priceEl.classList.toggle('is-sale', onSale);
    let compareEl = priceGroup.querySelector('.deinspar-size-price-compare');

    if (onSale) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'deinspar-size-price-compare';
        priceGroup.appendChild(compareEl);
      }
      compareEl.textContent = formatFrameMoney(compareCents);
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function syncCustomSizeUI() {
    const activeSize = getCurrentSizeLabel();

    // Consistent Deinspar price display in trigger, desktop list and mobile sheet.
    customSizeOptions.forEach(option => {
      const cents = option.getAttribute('data-size-price');
      if (cents !== null && Number.isFinite(Number(cents))) {
        const price = option.querySelector('.custom-size-option__price, .custom-size-sheet-option__price');
        if (price) price.textContent = formatFrameMoney(cents);
      }
      const compareCents = option.getAttribute('data-size-compare-price');
      if (compareCents !== null && Number.isFinite(Number(compareCents))) {
        const compare = option.querySelector('.custom-size-option__compare, .custom-size-sheet-option__compare');
        if (compare) compare.textContent = formatFrameMoney(compareCents);
      }
    });
    if (customSizeTriggerText) {
      customSizeTriggerText.textContent = activeSize || '';
    }
    if (customSizeTriggerPrice) {
      const activeOption = [...customSizeOptions].find(option =>
        option.classList.contains('custom-size-option') &&
        (option.getAttribute('data-custom-size-value') || '').trim() === activeSize
      );
      const cents = activeOption?.getAttribute('data-size-price');
      const compareCents = activeOption?.getAttribute('data-size-compare-price');
      const hasPrice = cents !== null && cents !== undefined && cents !== '' &&
        Number.isFinite(Number(cents));
      customSizeTriggerPrice.textContent = hasPrice ? formatFrameMoney(cents) : '';
      setSizeTriggerPriceSaleState(
        customSizeTriggerPrice,
        hasPrice ? Number(cents) : 0,
        hasPrice && compareCents !== null ? Number(compareCents) : 0
      );
    }

    customSizeOptions.forEach(function(option) {
      const value = (option.getAttribute('data-custom-size-value') || '').trim();
      option.classList.toggle('is-active', value === activeSize);
    });
  }

  function syncCustomFrameUI() {
    const activeFrame = getCurrentFrameLabel();
    customFrameCards.forEach(function(card) {
      const value = (card.getAttribute('data-custom-frame-value') || '').trim();
      const active = virtualFrameKey
        ? card.dataset.deinsparFrameKey === virtualFrameKey
        : value === activeFrame;
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    refreshFrameOverlay();
    updateCustomFrameTrigger();
  }

  function syncCustomVariantUI() {
    syncCustomSizeUI();
    syncCustomFrameUI();
    updateCustomFrameCardPrices();
  }

  // DEINSPAR: Wenn ein Rahmen gewaehlt wird, wieder das eigentliche Poster
  // (Shopify-Bildposition 1) anzeigen, damit dessen Rahmen-Overlay sichtbar ist.
  // Aendert weder die ausgewaehlte Variante noch Preis oder Warenkorb.
  function showPosterImageAfterFrameSelection() {
    const productRoot = customFramePicker?.closest('.product__item-js');
    const gallery = productRoot?.querySelector('media-gallery');
    if (!gallery) return;

    const slider = gallery.querySelector('slide-with-thumbs');
    if (slider?.globalSlide) {
      const swiper = slider.globalSlide;
      const slides = Array.from(swiper.slides || []);
      const firstPosterIndex = slides.findIndex(slide =>
        slide.getAttribute('data-position') === '1'
      );
      const target = firstPosterIndex >= 0 ? firstPosterIndex : 0;
      if (swiper.activeIndex !== target) swiper.slideTo(target, 450);
      return;
    }

    // Bei horizontal scrollbar angeordneten Produktbildern ohne Swiper
    // nur die Galerie zurueck zum ersten Bild bewegen, nicht die ganze Seite.
    const grid = gallery.querySelector('[id^="GalleryViewer"]');
    if (grid && grid.scrollWidth > grid.clientWidth) {
      grid.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }

  if (customFrameTrigger) {
    customFrameTrigger.addEventListener('click', function() {
      if (customFramePicker?.classList.contains('is-open')) {
        closeCustomFramePicker();
      } else {
        openCustomFramePicker();
      }
    });
  }

  if (customSizeTrigger) {
    customSizeTrigger.addEventListener('click', function() {
      if (customSizePicker && customSizePicker.classList.contains('is-open')) {
        closeCustomSizePicker();
      } else {
        openCustomSizePicker();
      }
    });
  }

  customSizeOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      if (option.disabled || option.classList.contains('is-disabled')) return;

      const sizeValue = option.getAttribute('data-custom-size-value');
      const changed = clickNativeOption(0, sizeValue);
      if (!changed) return;

      closeCustomSizePicker();

      setTimeout(syncCustomVariantUI, 0);
      setTimeout(syncCustomVariantUI, 180);
      setTimeout(updateTotalPrice, 0);
    });
  });

  customFrameCards.forEach(function(card) {
    card.addEventListener('click', function() {
      if (card.disabled || card.classList.contains('is-disabled')) return;
      const isExtraFrame = card.dataset.deinsparVirtualFrame === 'true';

      if (isExtraFrame) {
        if (!isSizeOnlyPoster) {
          // Legacy: Poster-Variante "Ohne Rahmen" ist Basis für virtuelle Farben.
          const noFrameCard = [...customFrameCards].find(el => el.dataset.deinsparFrameKey === 'none');
          if (!noFrameCard || !clickNativeOption(1, noFrameCard.dataset.customFrameValue)) {
            console.error('DEINSPAR: Keine Poster-Basisvariante ohne Rahmen gefunden.');
            return;
          }
        }
        // Neu: Poster besitzt nur eine Größenvariante; niemals option2 anklicken.
        virtualFrameKey = card.dataset.deinsparFrameKey;
        virtualFrameLabel = card.querySelector('.custom-frame-card__title')?.textContent?.trim() || virtualFrameKey;
      } else {
        const frameValue = card.getAttribute('data-custom-frame-value');
        if (!clickNativeOption(1, frameValue)) return;
        virtualFrameKey = '';
        virtualFrameLabel = '';
      }

      syncCustomVariantUI();
      closeCustomFramePicker();
      // Auch bei Auswahl aus dem mobilen Options-Drawer wird die echte
      // Poster-Galerie umgeschaltet, ohne die Seite hochzuscrollen.
      setTimeout(showPosterImageAfterFrameSelection, 80);
      setTimeout(syncCustomVariantUI, 0);
      setTimeout(syncCustomVariantUI, 180);
      setTimeout(updateTotalPrice, 0);
      setTimeout(updateTotalPrice, 180);
    });
  });

  customFrameCloseButtons.forEach(function(btn) {
    btn.addEventListener('click', closeCustomFramePicker);
  });

  customSizeCloseButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeCustomSizePicker();
    });
  });

  document.addEventListener('click', function(event) {
    if (customFramePicker && !customFramePicker.contains(event.target)) {
      closeCustomFramePicker();
    }
    if (!customSizePicker) return;
    if (isMobileCustomSizeView()) return;
    if (customSizePicker.contains(event.target)) return;
    closeCustomSizePicker();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeCustomSizePicker();
      closeCustomFramePicker();
    }
  });

  // DEINSPAR: Mobile Safari/Chrome can fire resize while opening the
  // right-hand size/frame drawer (e.g. browser bar changing height).
  // Do not close the active picker for an ordinary viewport resize.
  // Reset it only when the layout actually switches mobile <-> desktop.
  const deinsparPickerLayout = window.matchMedia('(max-width: 768px)');
  const deinsparOnPickerLayoutChange = function() {
    closeCustomSizePicker();
    closeCustomFramePicker();
  };
  if (typeof deinsparPickerLayout.addEventListener === 'function') {
    deinsparPickerLayout.addEventListener('change', deinsparOnPickerLayoutChange);
  } else if (typeof deinsparPickerLayout.addListener === 'function') {
    deinsparPickerLayout.addListener(deinsparOnPickerLayoutChange);
  }

  /* DEINSPAR | Getrennte Einzel- und Set-Rahmen aus Shopify (Snippet v2).
     frames: Einzelverkaufspreis; setFrames: echte Set-Variante fuer den Warenkorb.
     Keine kuenstlichen Prozent-Rabatte im JavaScript. */
  const frameDataElement = document.querySelector('[data-deinspar-frame-data]');
  let frameProducts = {};       // Set-Rahmen (tatsaechlich in den Warenkorb)
  let retailFrameProducts = {}; // Normale Rahmen (nur als Vergleichspreis)
  let frameCurrency = window.Shopify?.currency?.active || 'EUR';
  const retailPriceBySetVariantId = new Map();

  try {
    if (!frameDataElement) throw new Error('deinspar-frame-data Snippet fehlt.');
    const source = JSON.parse(frameDataElement.textContent);
    if (!source.collectionFound || !source.setFrames || !source.frames ||
        !Object.keys(source.setFrames).length || !Object.keys(source.frames).length) {
      throw new Error('Set- und Einzelrahmen fehlen im Snippet. Bitte Metafeld custom.set_frames pruefen.');
    }
    frameProducts = source.setFrames;
    retailFrameProducts = source.frames;
    frameCurrency = source.currency || frameCurrency;

    // Echte Shopify-Varianten anhand von Farbe UND normalisierter Groesse koppeln.
    Object.entries(frameProducts).forEach(([colour, setProduct]) => {
      const retailProduct = retailFrameProducts[colour];
      (setProduct.variants || []).forEach(setVariant => {
        const size = normalizeSizeLabel(setVariant.size);
        const retailVariant = size && (retailProduct?.variants || []).find(v =>
          normalizeSizeLabel(v.size) === size
        );
        if (retailVariant) {
          retailPriceBySetVariantId.set(String(setVariant.id), Number(retailVariant.price));
        } else {
          console.warn('DEINSPAR: Einzelrahmen-Vergleich fehlt:', colour, size || setVariant.size);
        }
      });
    });
    console.info('DEINSPAR: Set-Rahmen geladen:', Object.keys(frameProducts).length,
      '| zugeordnete Preisvarianten:', retailPriceBySetVariantId.size);
  } catch (error) {
    // Absichtlich KEIN stiller Rueckfall auf normalpreisige Rahmen.
    // Sonst koennte ein Kunde trotz Set-Auswahl den falschen Artikel bestellen.
    console.error('DEINSPAR: Set-Rahmendaten konnten nicht geladen werden:', error);
  }

  function normalizeSizeLabel(value) {
    // Funktioniert auch für mehrsprachige Größen wie: 40×50 cm (16" × 20" in).
    const text = String(value || '').replace(/[×✕]/g, 'x');
    const size = text.match(/(\d{2,3})\s*[xX]\s*(\d{2,3})/);
    return size ? Number(size[1]) + 'x' + Number(size[2]) : '';
  }

  function normalizeFrameMapPart(value) {
    return String(value || '').replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function getFrameKey(frameLabel) {
    if (virtualFrameKey) return virtualFrameKey;
    const label = normalizeFrameMapPart(frameLabel);
    const card = Array.from(customFrameCards).find(item =>
      normalizeFrameMapPart(item.getAttribute('data-custom-frame-value')) === label
    );
    return card?.getAttribute('data-deinspar-frame-key') || '';
  }

  function lookupFrameVariant(frameKey, sizeLabel) {
    if (frameKey === 'none') return { status: 'none', variant: null };
    const product = frameProducts[frameKey];
    const wantedSize = normalizeSizeLabel(sizeLabel);
    if (!frameKey || !product || !wantedSize) return { status: 'missing', variant: null };

    const variant = (product.variants || []).find(item =>
      normalizeSizeLabel(item.size) === wantedSize
    );
    if (!variant || !variant.available) return { status: 'unavailable', variant: null };
    if (!retailPriceBySetVariantId.has(String(variant.id))) {
      // Keine vollstaendige Zuordnung? Kombination lieber sperren als falsch berechnen.
      return { status: 'missing', variant: null };
    }
    return { status: 'found', variant };
  }

  function getSelectedFrameChoice() {
    return lookupFrameVariant(getFrameKey(getCurrentFrameLabel()), getCurrentSizeLabel());
  }

  // Der guenstige Preis kommt aus der echten Set-Variante in Shopify.
  // Als VP verwenden wir ausschliesslich den ORIGINALEN Einzelverkaufspreis
  // derselben Farbe und Groesse, niemals das Shopify-compare_at_price.
  function getFrameSetPrices(variant) {
    const setPrice = Math.max(0, Math.round(Number(variant?.price) || 0));
    const retailPrice = retailPriceBySetVariantId.get(String(variant?.id));
    if (!Number.isFinite(retailPrice)) {
      // Dieses Szenario wird bereits durch lookupFrameVariant blockiert.
      return { price: setPrice, compareAtPrice: setPrice };
    }
    return {
      price: setPrice,
      compareAtPrice: Math.max(setPrice, Math.round(retailPrice))
    };
  }

  function formatFrameMoney(cents) {
    const currency = frameCurrency || 'EUR';
    const locale = document.documentElement.lang || window.Shopify?.locale || 'de-DE';
    try {
      // Shopify returns cent amounts; Intl correctly formats comma and currency by locale.
      return new Intl.NumberFormat(locale.replace('_', '-'), {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100)
        .replace(/[\u00a0\u202f]/g, ' ')
        .replace(/\s*,\s*/g, ',');
    } catch (error) {
      return Shopify.formatMoney(Number(cents) || 0,
        themeGlobalVariables?.settings?.money_format || '${{amount}}')
        .replace(/\s*,\s*/g, ',');
    }
  }

  function showFrameUnavailableMessage() {
    const language = (window.Shopify?.locale || document.documentElement.lang || 'en')
      .toLowerCase().split('-')[0];
    const messages = {
      de: 'Dieser Rahmen ist in der gewählten Größe nicht verfügbar. Bitte wähle einen anderen Rahmen oder „Ohne Rahmen“.',
      en: 'This frame is not available in the selected size. Please choose another frame or No Frame.',
      fr: 'Ce cadre n’est pas disponible dans la taille choisie. Veuillez choisir un autre cadre ou sans cadre.',
      it: 'Questa cornice non è disponibile nella misura scelta. Scegli un’altra cornice o senza cornice.',
      es: 'Este marco no está disponible en el tamaño elegido. Elige otro marco o sin marco.',
      nl: 'Deze lijst is niet beschikbaar in het gekozen formaat. Kies een andere lijst of geen lijst.',
      da: 'Denne ramme findes ikke i den valgte størrelse. Vælg en anden ramme eller uden ramme.',
      no: 'Denne rammen er ikke tilgjengelig i valgt størrelse. Velg en annen ramme eller uten ramme.',
      nb: 'Denne rammen er ikke tilgjengelig i valgt størrelse. Velg en annen ramme eller uten ramme.',
      sv: 'Den här ramen finns inte i vald storlek. Välj en annan ram eller utan ram.'
    };
    window.alert(messages[language] || messages.en);
  }

  async function updateCustomFrameCardPrices() {
    if (!customFrameCardPrices.length) return;
    const size = getCurrentSizeLabel();

    customFrameCardPrices.forEach(priceEl => {
      const card = priceEl.closest('[data-custom-frame-value]');
      const frameKey = card?.getAttribute('data-deinspar-frame-key') || '';
      const choice = lookupFrameVariant(frameKey, size);
      if (card) {
        // Ursprünglich von den Poster-Optionen deaktivierte Karten deaktiviert lassen.
        if (!card.hasAttribute('data-deinspar-base-disabled')) {
          card.dataset.deinsparBaseDisabled = card.disabled ? 'true' : 'false';
        }
        const unavailable = choice.status === 'missing' || choice.status === 'unavailable';
        card.disabled = card.dataset.deinsparBaseDisabled === 'true' || unavailable;
        card.classList.toggle('is-disabled', card.disabled);
      }
      const setPrices = choice.status === 'found'
        ? getFrameSetPrices(choice.variant)
        : { price: 0, compareAtPrice: 0 };
      priceEl.textContent = choice.status === 'none'
        ? '+' + formatFrameMoney(0)
        : choice.status === 'found'
          ? '+' + formatFrameMoney(setPrices.price)
          : '—';
      setFramePriceSaleState(priceEl, setPrices.price, setPrices.compareAtPrice);
    });
    updateCustomFrameTrigger();
  }

  /* DEINSPAR – Gesamtpreis und Gesamtvergleichspreis aus Poster + Rahmen */
  const priceBox = document.querySelector('.card-product-price .price');
  const priceContainer = priceBox?.closest('.card-product-price');

  function startPriceLoading() {
    priceBox?.classList.add('is-loading');
    priceContainer?.querySelector('.compare-price')?.classList.add('is-loading');
  }

  function finishPriceLoading() {
    priceBox?.classList.remove('is-loading');
    priceContainer?.querySelector('.compare-price')?.classList.remove('is-loading');
  }

  function formatTotalMoney(cents) {
    let formatted = Shopify.formatMoney(
      cents,
      themeGlobalVariables?.settings?.money_format || "${{amount}}"
    );
    const euroSuffixCountries = ['DE', 'AT', 'FR', 'IT', 'ES', 'PT', 'BE', 'LU', 'NL'];
    const country = window.Shopify?.country || window.localization?.country?.iso_code;
    if (euroSuffixCountries.includes(country)) {
      formatted = formatted.replace('€', '').trim() + ' €';
    }
    return formatted.replace(/\s*,\s*/g, ',');
  }

  function updateCombinedPriceDisplay(total, totalCompare, posterPrice, posterComparePrice) {
    if (!priceBox || !priceContainer) return;
    const onSale = totalCompare > total;

    priceBox.textContent = formatTotalMoney(total);
    priceBox.classList.toggle('deinspar-total-price--sale', onSale);
    priceBox.classList.toggle('deinspar-total-price--regular', !onSale);
    priceBox.classList.toggle('price--special', onSale);
    priceBox.classList.toggle('special-price', onSale);
    priceBox.closest('.price-regular')?.classList.toggle('primary-color', onSale);

    // Shopify liefert dieses Element bei einem ursprünglich nicht rabattierten
    // Poster nicht. Bei einem Rabatt nur auf den Rahmen legen wir es selbst an.
    let comparePriceBox = priceContainer.querySelector('.compare-price');
    if (onSale && !comparePriceBox) {
      const compareWrapper = document.createElement('div');
      compareWrapper.className = 'price-regular deinspar-total-compare-wrapper';
      comparePriceBox = document.createElement('s');
      comparePriceBox.className = 'price-item compare-price dark-grey';
      compareWrapper.appendChild(comparePriceBox);
      priceContainer.appendChild(compareWrapper);
    }

    if (comparePriceBox) {
      comparePriceBox.classList.add('deinspar-total-compare');
      comparePriceBox.textContent = onSale ? formatTotalMoney(totalCompare) : '';
      // Im Original-Theme liegt der Vergleichspreis in einer eigenen Hülle.
      // Wir schalten nur diese Hülle ein/aus, nicht den gesamten Preisblock.
      comparePriceBox.parentElement.style.display = onSale ? '' : 'none';
      // Bei unserem eigenen Wrapper ist das <s> direkter Kindknoten.
      // Bei einem bestehenden Liquid-Element ist die Hülle meistens ein <div>.
      if (comparePriceBox.parentElement.classList.contains('deinspar-total-compare-wrapper')) {
        comparePriceBox.parentElement.style.display = onSale ? '' : 'none';
      }
    }

    // Das Badge zeigt NUR den Poster-Rabatt (ohne Rahmen/Set-Rabatt).
    // Die bestehenden Gesamtpreis-Daten bleiben für andere Funktionen erhalten.
    const productRootForBadge = priceContainer.closest('[id^="MainProduct-"]');
    if (productRootForBadge) {
      // Auch bei späterem Laden des Badge-Skripts sind Posterpreise verfügbar.
      productRootForBadge.dataset.deinsparCombinedPrice = String(total);
      productRootForBadge.dataset.deinsparCombinedCompare = String(totalCompare);
      productRootForBadge.dataset.deinsparPosterPrice = String(posterPrice);
      productRootForBadge.dataset.deinsparPosterCompare = String(posterComparePrice);
      productRootForBadge.dispatchEvent(new CustomEvent(
        'deinspar:combined-price-updated', {
          detail: {
            price: total,
            compareAtPrice: totalCompare,
            posterPrice: posterPrice,
            posterCompareAtPrice: posterComparePrice
          },
          bubbles: true
        }
      ));
    }
  }

  async function updateTotalPrice() {
    if (!priceBox) return;

    const variantInput = document.querySelector('input[name="id"]');
    const posterId = variantInput?.value;
    const variantOptions = variantInput?.closest('.product-detail__information')
      ?.querySelectorAll('.free-master-select option') || [];
    let posterPrice = 0;
    let posterComparePrice = 0;
    let foundInOptions = false;

    for (const option of variantOptions) {
      if (String(posterId) !== String(option.value)) continue;
      const rawPrice = option.getAttribute('masterdatapr');
      const rawCompare = option.getAttribute('masterdatacpr');
      if (rawPrice !== null && rawPrice !== '' && Number.isFinite(Number(rawPrice))) {
        posterPrice = Number(rawPrice);
        posterComparePrice = Number(rawCompare) || 0;
        foundInOptions = true;
      }
      break;
    }

    if (!foundInOptions && posterId) {
      const marketMatch = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]{2})/);
      const marketPrefix = marketMatch ? marketMatch[1] : '';
      try {
        const response = await fetch(`${marketPrefix}/variants/${posterId}.js`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const posterData = await response.json();
        posterPrice = Number(posterData?.price) || 0;
        posterComparePrice = Number(posterData?.compare_at_price) || 0;
      } catch (error) {
        console.warn('DEINSPAR: Posterpreis konnte nicht geladen werden:', error);
        return; // Keine falsche Summe ohne Posterpreis anzeigen.
      }
    }

    const selectedFrame = getSelectedFrameChoice();
    const setPrices = selectedFrame.status === 'found'
      ? getFrameSetPrices(selectedFrame.variant)
      : { price: 0, compareAtPrice: 0 };

    // Poster ohne eigenen VP: Verkaufs-/Einzelpreis gilt als Vergleichsbasis.
    // Rahmen im Set: guenstiger Produktpreis aus Shopify statt JS-Rabatt.
    // So bleibt ein Poster-Rabatt UND der Set-Rahmenrabatt sichtbar.
    const posterRegular = Math.max(posterPrice, posterComparePrice);
    const total = posterPrice + setPrices.price;
    const totalCompare = posterRegular + setPrices.compareAtPrice;

    updateCombinedPriceDisplay(total, totalCompare, posterPrice, posterComparePrice);
  }

 /* ▼ Ereignisse verdrahten + Soft-Fade ------------------------------ */
  async function hookPriceEvents() {
    const hideAndUpdate = () => {
  startPriceLoading();                //  <-- Hier neu
  clearTimeout(hideAndUpdate.t);      //  kleines Debounce gegen Doppler
  hideAndUpdate.t = setTimeout(() =>
    updateTotalPrice().then(finishPriceLoading)
  , 0);
};


    dropdowns.forEach(opt => opt.addEventListener('click', hideAndUpdate));

    document.addEventListener('change', e => {
      if (e.target.name === 'id' || e.target.name?.startsWith('options'))
        hideAndUpdate();
    });
  }

  /* Initial & Events - KORREKTE REIHENFOLGE */
  try {
    console.log('🚀 Starte Initialisierung...');
    
    // 1. Rahmenpreise sind bereits im HTML enthalten; kein Vorladen nötig.
    console.log('✅ Shopify-Rahmenpreise verfügbar');
    
    // 2. DANN Events verdrahten
    hookPriceEvents();
    
    // 3. DANN erste Preisberechnung
    await updateTotalPrice();
    priceBox?.classList.remove('is-loading');

    // 4. Custom UI initial synchronisieren
    syncCustomVariantUI();

    console.log('✅ Preise berechnet');
    
    // 5. Event-Listener für spätere Änderungen
    document.addEventListener('variant:change', function() {
      updateTotalPrice();
      setTimeout(syncCustomVariantUI, 0);
      setTimeout(syncCustomVariantUI, 180);
    });

    dropdowns[1]?.addEventListener('click', () => {
      setTimeout(updateTotalPrice, 0);
      setTimeout(syncCustomVariantUI, 0);
      setTimeout(syncCustomVariantUI, 180);
    });

    dropdowns[0]?.addEventListener('click', () => {
      setTimeout(updateTotalPrice, 0);
      setTimeout(syncCustomVariantUI, 0);
      setTimeout(syncCustomVariantUI, 180);
    });
    
    console.log('🎉 Initialisierung komplett!');
  } catch (error) {
    console.error('❌ Fehler bei der Initialisierung:', error);
  }


  // Neue Poster haben genau EINE native Option (Größe), ältere weiterhin ZWEI.
  if (!mainButton || dropdowns.length < (isSizeOnlyPoster ? 1 : 2)) {
    console.warn('🚫 Hauptbutton oder Größen-Dropdown nicht gefunden');
    return;
  }

  /* ▼ Helper – Cart-Meta (Badge, Icon, Progress) aktualisieren ----------- */
  async function updateCartMeta(cartDrawer) {
    try {
      const cart = await fetch('/cart.json').then(r => r.json());
          /* ---------- Warenkorb-Icon (Pfad) umschalten ---------- */
    const PATH_EMPTY = 'M655.42,252.64H808.17L880.39,944.4H61.66l63.11-691.76H655.42ZM470.9,0c-116,.05-212.35,84.18-231.37,194.79l-.2,1.4v1.4h-166L0,1000H940.74l-83-802.41H702.47C683.75,85.08,587.26.3,470.9.05h0ZM302.64,197.59c17.46-79,85.83-137.53,168.26-139.74h.25A177.49,177.49,0,0,1,640,195l.25,1.2v1.4Z';
    const PATH_FULL  = 'M857.34,197.47H701.07C682.67,84.86,586.11,0,469.75,0S256.83,84.86,238.57,196.12l-.2,1.35H72.46L0,1000H940.29ZM470.2,80.76A155.26,155.26,0,0,1,618.71,195.27l.25,1.1H320c18-67.06,78.26-115.61,149.82-115.61h.35Z';

    const cartBubble = document.getElementById('cart-icon-bubble');
    const cartPath   = cartBubble?.querySelector('svg path');

    if (cartPath) {
      cartPath.setAttribute('d', cart.item_count > 0 ? PATH_FULL : PATH_EMPTY);
    }

      /* 1) Badge-Zähler -------------------------------------------------- */
      if (cart.item_count !== undefined) {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = el.classList.contains('cart-count-drawer')
            ? `(${cart.item_count})`
            : cart.item_count;
        });

        /* 1a) Icon sofort füllen / leeren ------------------------------- */
        const cartBubble = document.getElementById('cart-icon-bubble');
        const cartPath   = cartBubble?.querySelector('svg path');
        if (cartPath) {
          cartPath.style.fill = cart.item_count > 0 ? 'currentColor'
                                                    : 'transparent';
        }
      }

      /* 2) Drawer-Titel "Einkaufswagen (x)" ----------------------------- */
      const titleCount = cartDrawer?.querySelector('.cart-heading-count');
      if (titleCount) titleCount.textContent = `(${cart.item_count})`;

      /* 3) Gratis-Versand-Progress -------------------------------------- */
      const progress = cartDrawer?.querySelector('free-ship-progress-bar');
      if (progress?.init) progress.init(cart.items_subtotal_price);

    } catch (err) {
      console.error('⚠️ Cart-Meta-Update fehlgeschlagen:', err);
    }
  }

  /* ▼ Add-to-Cart-Handler ----------------------------------------------- */
  mainButton.addEventListener('click', async (event) => {
    event.preventDefault();

    const selectedFrame = getSelectedFrameChoice();
    if (selectedFrame.status !== 'none' && selectedFrame.status !== 'found') {
      console.error('DEINSPAR: Rahmen-Größe nicht zugeordnet:', {
        size: getCurrentSizeLabel(), frame: getCurrentFrameLabel()
      });
      showFrameUnavailableMessage();
      return; // Wichtig: Nicht versehentlich nur das Poster hinzufügen.
    }

    loaderIcon?.classList.remove('opacity-0');
    loaderIcon?.classList.add('opacity-100', 'spin');

    const btnLabel = mainButton.querySelector('.btn-label');   // <span>In den Warenkorb</span>
   btnLabel && (btnLabel.style.opacity = '0');               // Text ausblenden

    const form      = mainButton.closest('form');
    const formData  = new FormData(form);
    const variantId = formData.get('id');           // Poster-Variante

const frameId = selectedFrame.status === 'found'
  ? selectedFrame.variant.id
  : null;
    
    if (!variantId) {
      console.error('❌ Poster-Variant-ID fehlt');
      loaderIcon?.classList.remove('opacity-100', 'spin');
      loaderIcon?.classList.add('opacity-0');
      if (btnLabel) btnLabel.style.opacity = '1';
      return;
    }

    const posterQuantityInput = document.querySelector('input[name="quantity"]');
    const posterQuantity = posterQuantityInput ? parseInt(posterQuantityInput.value) : 1;
    
    const items = [{ id: variantId, quantity: posterQuantity }];
    if (frameId) {
      // Eindeutige Set-ID: Vorbereitung fuer Option A im Mini Cart und Warenkorb.
      // Beide Positionen koennen spaeter gezielt zusammen entfernt werden.
      const setId = (window.crypto?.randomUUID?.() ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      items[0].properties = {
        _deinspar_set_id: setId,
        _deinspar_set_role: 'poster',
        ...(virtualFrameKey ? { _deinspar_frame_colour: virtualFrameKey } : {})
      };
      items.push({
        id: frameId,
        quantity: posterQuantity,
        properties: {
          _deinspar_set_id: setId,
          _deinspar_set_role: 'frame',
          _parent_poster_id: variantId.toString()
        }
      });
    } else if (virtualFrameKey && virtualFrameKey !== 'none') {
      items[0].properties = { _deinspar_frame_colour: virtualFrameKey };
    }

/* Abschnitte für Drawer / Notification ------------------------------ */
const cartDrawer =
  document.querySelector("cart-drawer") ||
  document.querySelector("cart-notification");

const sections = cartDrawer
  ? cartDrawer.getSectionsToRender().map((s) => s.id)
  : [];

try {
  const url =
    `/cart/add.js?sections=${sections.join(",")}` +
    `&sections_url=${encodeURIComponent(window.location.pathname)}`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ items }),
  });

  const json = await res.json();
  if (!res.ok) throw new Error(json?.description || json?.message || 'Shopify cart add failed');

  // 🔽 ab hier: normales Verhalten (Drawer öffnen, Inhalte aktualisieren)
  const sectionsMap = json && json.sections ? json.sections : {};

  if (sections.length && sectionsMap) {
    sections.forEach((id) => {
  const target = document.getElementById(id);
  const htmlString = sectionsMap[id];
  if (!target || !htmlString) return;

  const html = new DOMParser().parseFromString(htmlString, "text/html");
  const source = html.getElementById(id);

  if (source) {
    target.innerHTML = source.innerHTML;
  }
});

    cartDrawer?.cartAction?.();
    cartDrawer?.open?.();
  }

  await updateCartMeta(cartDrawer);

  console.log("🛍️ Warenkorb & Mini-Cart aktualisiert");
} catch (err) {
  console.error("❌ Fehler beim AJAX-Add-to-Cart:", err);
} finally {
  loaderIcon?.classList.remove("opacity-100", "spin");
  loaderIcon?.classList.add("opacity-0");
  if (btnLabel) btnLabel.style.opacity = "1";
}
  });
});
/* =========================================================
   SIZE GUIDE MODAL
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-size-guide-modal]');
  const openButtons = document.querySelectorAll('[data-size-guide-open]');
  const closeButtons = document.querySelectorAll('[data-size-guide-close]');
  const poster = document.querySelector('[data-size-guide-poster]');
  const label = document.querySelector('[data-size-guide-label]');
  const sizeButtons = document.querySelectorAll('[data-size-guide-size]');
  const prevButton = document.querySelector('[data-size-guide-prev]');
  const nextButton = document.querySelector('[data-size-guide-next]');
  const sizeTriggerText = document.querySelector('[data-custom-size-trigger-text]');

if (!modal || !poster || !label || !sizeButtons.length) return;

if (modal.parentNode !== document.body) {
  document.body.appendChild(modal);
}

  if (!modal || !poster || !label || !sizeButtons.length) return;

  const sizes = [
  {
    key: '21x30 cm',
    label: '21 x 30 cm',
    width: 44,
    height: 63
  },
  {
    key: '30x40 cm',
    label: '30 x 40 cm',
    width: 64,
    height: 85
  },
  {
    key: '50x70 cm',
    label: '50 x 70 cm',
    width: 106,
    height: 148
  },
  {
    key: '70x100 cm',
    label: '70 x 100 cm',
    width: 148,
    height: 212
  }
];

  function normalizeSizeValue(value) {
    const raw = String(value || '');
    // Legacy Shopify variant labels may also contain "(8" x 12" in)".
    const originalCm = raw.match(/(\d+)\s*[x×]\s*(\d+)\s*cm\b/i);
    if (originalCm) return `${originalCm[1]}x${originalCm[2]}cm`;
    return raw.replace(/\s+/g, '').replace('×', 'x').toLowerCase();
  }

  function findSizeIndex(value) {
    const normalized = normalizeSizeValue(value);

    return sizes.findIndex(function (item) {
      return normalizeSizeValue(item.key) === normalized || normalizeSizeValue(item.label) === normalized;
    });
  }

  function getCurrentSelectedSize() {
    // DEINSPAR Cm/In: never read the visually converted inch label here.
    // The original cm variant value remains in data-custom-size-value.
    const activeButton = document.querySelector('.custom-size-option.is-active[data-custom-size-value]')
      || document.querySelector('.custom-size-sheet-option.is-active[data-custom-size-value]');
    if (activeButton) {
      return activeButton.getAttribute('data-custom-size-value') || '21x30 cm';
    }

    if (sizeTriggerText) {
      return sizeTriggerText.getAttribute('data-deinspar-size-raw')
        || sizeTriggerText.textContent.trim()
        || '21x30 cm';
    }

    return '21x30 cm';
  }

  let currentIndex = findSizeIndex(getCurrentSelectedSize());
  if (currentIndex < 0) currentIndex = 0;

  function applySize(index) {
  const size = sizes[index];
  if (!size) return;

  currentIndex = index;

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  let width = size.width;
  let height = size.height;

  if (isMobile) {
    const mobileSizes = {
    '21x30 cm': { width: 32, height: 46 },
'30x40 cm': { width: 43, height: 58 },
'50x70 cm': { width: 65, height: 91 },
'70x100 cm': { width: 88, height: 126 }
    };

    const mobileSize = mobileSizes[size.key];
    if (mobileSize) {
      width = mobileSize.width;
      height = mobileSize.height;
    }
  }

  poster.style.setProperty('--size-guide-poster-width', width + 'px');
  poster.style.setProperty('--size-guide-poster-height', height + 'px');
  poster.setAttribute('data-size-value', size.key);
  label.textContent = size.label;

  sizeButtons.forEach(function (button) {
    const buttonValue = button.getAttribute('data-size-guide-size');
    const isActive = normalizeSizeValue(buttonValue) === normalizeSizeValue(size.key);
    button.classList.toggle('is-active', isActive);
  });
}

  function forceModalStyles() {
  const overlay = modal.querySelector('.size-guide-modal__overlay');
  const dialog = modal.querySelector('.size-guide-modal__dialog');

  modal.style.setProperty('position', 'fixed', 'important');
  modal.style.setProperty('inset', '0', 'important');
  modal.style.setProperty('z-index', '2147483647', 'important');
  modal.style.setProperty('display', 'block', 'important');
  modal.style.setProperty('width', '100vw', 'important');
  modal.style.setProperty('height', '100vh', 'important');
  modal.style.setProperty('pointer-events', 'auto', 'important');
  modal.style.setProperty('isolation', 'isolate', 'important');

  if (overlay) {
    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('inset', '0', 'important');
    overlay.style.setProperty('background', 'rgba(0,0,0,0.45)', 'important');
    overlay.style.setProperty('z-index', '0', 'important');
  }

  if (dialog) {
    dialog.style.setProperty('position', 'fixed', 'important');
    dialog.style.setProperty('top', '50%', 'important');
    dialog.style.setProperty('left', '50%', 'important');
    dialog.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
    dialog.style.setProperty('z-index', '1', 'important');
    dialog.style.setProperty('width', 'min(1120px, calc(100vw - 32px))', 'important');
    dialog.style.setProperty('max-height', 'min(88vh, 820px)', 'important');
    dialog.style.setProperty('overflow', 'auto', 'important');
    dialog.style.setProperty('background', '#ffffff', 'important');
    dialog.style.setProperty('box-shadow', '0 24px 80px rgba(0,0,0,0.18)', 'important');
  }
}

function hideEverythingBehindModal() {
  Array.from(document.body.children).forEach(function(node) {
    if (node === modal) return;
    node.dataset.sizeGuidePrevPointerEvents = node.style.pointerEvents || '';
    node.style.pointerEvents = 'none';
  });
}

function restoreEverythingBehindModal() {
  Array.from(document.body.children).forEach(function(node) {
    if (node === modal) return;
    if (node.dataset.sizeGuidePrevPointerEvents !== undefined) {
      node.style.pointerEvents = node.dataset.sizeGuidePrevPointerEvents;
      delete node.dataset.sizeGuidePrevPointerEvents;
    }
  });
}

function openModal() {
  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  modal.hidden = false;
  forceModalStyles();
  hideEverythingBehindModal();

  document.body.classList.add('size-guide-modal-open');

  const indexFromCurrentVariant = findSizeIndex(getCurrentSelectedSize());
  if (indexFromCurrentVariant >= 0) {
    applySize(indexFromCurrentVariant);
  } else {
    applySize(currentIndex);
  }
}

function closeModal() {
  modal.hidden = true;
  modal.style.display = 'none';

  restoreEverythingBehindModal();

  document.body.classList.remove('size-guide-modal-open');
}

  openButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      openModal();
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closeModal();
    });
  });

  sizeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const value = button.getAttribute('data-size-guide-size');
      const newIndex = findSizeIndex(value);
      if (newIndex >= 0) {
        applySize(newIndex);
      }
    });
  });

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      const newIndex = currentIndex <= 0 ? sizes.length - 1 : currentIndex - 1;
      applySize(newIndex);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      const newIndex = currentIndex >= sizes.length - 1 ? 0 : currentIndex + 1;
      applySize(newIndex);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
    }

    if (event.key === 'ArrowLeft') {
      const newIndex = currentIndex <= 0 ? sizes.length - 1 : currentIndex - 1;
      applySize(newIndex);
    }

    if (event.key === 'ArrowRight') {
      const newIndex = currentIndex >= sizes.length - 1 ? 0 : currentIndex + 1;
      applySize(newIndex);
    }
  });

  applySize(currentIndex);
closeModal();
});
document.addEventListener("click", function (e) {
  const clickedBlock = e.target.closest("collapsible-block.bls-toggle");
  if (!clickedBlock) return;

  setTimeout(function () {
    document.querySelectorAll("collapsible-block.bls-toggle").forEach(function (block) {
      if (block === clickedBlock) return;

      const content = block.querySelector(".collapsible-content");
      if (!content || content.style.display === "none") return;

      content.style.overflow = "hidden";
      content.style.height = content.scrollHeight + "px";
      content.style.transition = "height 0.25s ease";

      requestAnimationFrame(function () {
        content.style.height = "0px";
      });

      setTimeout(function () {
        content.style.display = "none";
        content.style.height = "";
        content.style.transition = "";
        content.style.overflow = "";
        block.classList.remove("is-open", "active", "open");
        block.removeAttribute("open");
      }, 260);
    });
  }, 80);
});